document.addEventListener('bss_b2b_doneCheckCp', () => {
  const cardWrappers = document.querySelectorAll(".card-wrapper");
  cardWrappers.forEach((cardWrapper)=>{
    const variantPrice = cardWrapper.querySelector("[bss-b2b-variant-price]");
    if (variantPrice && variantPrice.children.length === 0 && variantPrice.textContent.trim() !== "") {
      const saleBadge = cardWrapper.querySelector(".badge--onsale")
      if(saleBadge){
        saleBadge.remove()
      }
    }
  })
})
